import React from 'react'
import Field, { type IFieldProps } from './Field'
import { type Control, Controller, type RegisterOptions } from 'react-hook-form'
import RadioBtn from './RadioBtn'

interface IProps extends IFieldProps {
  name: string
  control: Control<any>
  rules?: RegisterOptions
  items: Array<string | { label: string; value: string }>
}

function RadioGroup(props: IProps): React.ReactElement {
  return (
    <Field
      {...{
        ...props,
        className: `radio-group ${props.className ?? ''}`.trim(),
      }}
      render={() => (
        <Controller
          name={props.name}
          control={props.control}
          rules={props.rules}
          render={({ field }) => (
            <div className="radio-group__items">
              {props.items.map((item) => {
                const label = typeof item === 'string' ? item : item.label
                const value = typeof item === 'string' ? item : item.value

                return (
                  <RadioBtn
                    disabled={props.disabled}
                    hasError={props.hasError}
                    key={value}
                    name={value}
                    label={label}
                    value={field.value ?? ''}
                    onChange={field.onChange}
                  ></RadioBtn>
                )
              })}
            </div>
          )}
        ></Controller>
      )}
    ></Field>
  )
}

export default RadioGroup
